import { Button, ButtonTypeMap, ExtendButtonBase } from '@mui/material';
import useOutlinedSecondaryButtonStyles from './styles';
import clsx from 'clsx';

type Component = ExtendButtonBase<ButtonTypeMap<{}, 'button'>>;
type Props = Parameters<Component>[0];

const Root = ({ children, className, ...props }: Props) => {
  const { root } = useOutlinedSecondaryButtonStyles();
  return (
    <Button className={clsx(root, className)} variant='outlined' color='secondary' {...props}>
      {children}
    </Button>
  );
};

export const OutlinedSecondaryButton = Root as Component;
